import { Loader2 } from 'lucide-react'
import { Cell } from '@highlight/ui'

export function ReminderLoading() {
  return (
    <Cell isPending clickable={false}>
      <Cell.Header showChevron={false}>
        <Cell.Icon>
          <Loader2 className="text-foreground-placeholder size-3 animate-spin" />
        </Cell.Icon>
        <Cell.Title>Creating reminder…</Cell.Title>
      </Cell.Header>
    </Cell>
  )
}
